




































// @ts-ignore
import v8n from 'v8n';
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { authModule, snackModule } from '@/store';
import { ApiError } from '@/api';
import LoginForm from '@/components/auth/LoginForm.vue';
import RegisterForm from '@/components/auth/RegisterForm.vue';

@Component({
  components: {
    LoginForm,
    RegisterForm,
  },
})
export default class extends Vue {
  loginTabs: number = 0;

  get maxWidth() {
    return this.loginTabs === 0 ? 350 : 700;
  }

  get loginDialog() {
    return authModule.loginDialog;
  }
  set loginDialog(d) {
    if (d) {
      authModule.openLoginDialog(null);
    } else {
      authModule.closeLoginDialog(false);
    }
  }

  registerSuccess() {
    // Deliberately stays on the Register tab: RegisterForm swaps itself for the
    // "check your email" state, which is the whole point of the new flow. Do
    // not switch to Login here - it would hide that message and tell the user
    // to log in as though nothing else were needed.
  }

  clearLogin() {
    if (this.$refs.loginComponent) {
      (this.$refs.loginComponent as LoginForm).clear();
    }
    if (this.$refs.registerComponent) {
      (this.$refs.registerComponent as RegisterForm).clear();
    }
  }

  @Watch('loginTabs')
  routeChanged() {
    this.clearLogin();
  }
}
